import React from "react";
import { Container } from "reactstrap";
import "./Comp-Header.css";


const CompHeaderElect = () => {

    return (
        <section>
            <Container className="comp-header-container">
                <div className="comp-header-title">
                    <b>Электр өрісіндегі диэлектриктер</b>
                </div>
                <div className="comp-header-content-container">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVVLtuaXcAJdV1vgbgWbWDM9K2D4XOnEiWlQ&usqp=CAU" alt="" />
                    <img className="src-image" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPSVy-EGakgcgkuYlhNeaiZ9h90G_iq6msxQ&usqp=CAU" alt="" />
                    <img className="src-image" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnDkAjFun_eIQhcW0aZNJOdP5ylFE8udY_ZA&usqp=CAU" alt="" />
                </div>
                <div className="component-content">
                    Электр өрісі актіде диэлектриктер олардың ішкі құрылымға сәйкес. Олар сондай-ақ, олар айтарлықтай электр өткізу емес, заттар болып табылады, белгілі, емес өткізгіштер деп аталады, өйткені жатыр. Олар осы Диэлектрик ішінде қозғалатын қабілетті болар еді бос заряд тасымалдаушылардың қамтымайды.
                </div>
            </Container>
        </section>
    );
};

export default CompHeaderElect;